export const CALL_SELECTED = 'CALL_SELECTED';

export const callSelected = (callId) => ({
    type: CALL_SELECTED,
    payload: { callId },
});



// WEBPACK FOOTER //
// ./src/pages/ConferenceDetail/conferenceDetailActions.js